import React, { useEffect, useState } from 'react'
import { Button, Collapse, Divider, Typography } from 'antd'
import { CommentType } from 'src/pages/budget/budgetRequests/types'
import dayjs from 'dayjs'

type PropsCommentList = {
  list: CommentType[]
  onAddComment?: () => void
}

export const CommentList = ({ list, onAddComment }: PropsCommentList) => {
  const { Text, Paragraph } = Typography
  const [activeKeys, setActiveKeys] = useState<string[]>(
    list.length > 0 ? ['comments'] : [],
  )

  useEffect(() => {
    if (list.length > 0) setActiveKeys(['comments'])
  }, [list.length])

  return (
    <Collapse
      activeKey={activeKeys}
      onChange={(keys) => setActiveKeys(Array.isArray(keys) ? keys : [keys])}
      items={[
        {
          key: 'comments',
          label: (
            <Text type="secondary" style={{ fontSize: 18 }}>
              Комментарии{list.length > 0 ? ` (${list.length})` : ''}
            </Text>
          ),
          children: (
            <>
              {onAddComment && (
                <Button
                  size="large"
                  variant="solid"
                  color="blue"
                  style={{ marginBottom: 16 }}
                  onClick={onAddComment}
                >
                  Оставить комментарий
                </Button>
              )}
              {list.length > 0 ? (
                <>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 4fr',
                      gap: 8,
                    }}
                  >
                    <Text type="secondary" style={{ fontSize: 16 }}>
                      Дата
                    </Text>
                    <Text type="secondary" style={{ fontSize: 16 }}>
                      Автор
                    </Text>
                    <Text type="secondary" style={{ fontSize: 16 }}>
                      Текст
                    </Text>

                    <Divider
                      style={{
                        gridColumn: '1 / -1',
                        margin: 0,
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 4fr',
                      gap: 8,
                      maxHeight: 100,
                      overflowY: 'auto',
                    }}
                  >
                    {list.map((item, index) => (
                      <React.Fragment key={item.commentId}>
                        <Text style={{ fontSize: 16 }}>
                          {dayjs(item.updatedAt).format('DD.MM.YYYY')}
                        </Text>

                        <Text style={{ fontSize: 16 }}>
                          {item.user.firstName} {item.user.lastName}
                        </Text>

                        <Paragraph
                          ellipsis={{
                            rows: 1,
                            expandable: 'collapsible',
                          }}
                          style={{ fontSize: 16 }}
                        >
                          {item.message}
                        </Paragraph>

                        {index < list.length - 1 && (
                          <Divider
                            style={{
                              gridColumn: '1 / -1',
                              margin: 0,
                            }}
                          />
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </>
              ) : (
                <Text type="secondary">Нет комментариев</Text>
              )}
            </>
          ),
        },
      ]}
      size="small"
      expandIconPosition="end"
    />
  )
}
